import { createLabeledMessages } from '../../../messageUtils';
const person = {
    firstName: 'first name',
    surname: 'surname'
};
const special = {
    char: 'character',
    char_other: 'characters',
    file: 'file',
    file_one: 'file',
    file_other: 'files'
};
const common = {
    from: 'from',
    to: 'to',
    yes: 'yes',
    no: 'no',
    unknown: 'unknown',
    choose: 'choose',
    close: 'close',
    name: 'name',
    note: 'note',
    pageSize: 'page size',
    loading: 'Loading',
    back: 'Back',
    ok: 'Ok',
    loadingApplication: 'Loading application'
};
const auth = {
    accessDenied: 'You do not have access to this component'
};
const generic = {
    noRecord: 'No record found',
    copied: 'Copied',
    provideDetailsInReport: 'Provide the details when reporting the problem, e.g. via HelpDesk',
    retry: 'Retry',
    error: 'Error',
    closeAll: 'Close all',
    application: 'Application',
    user: 'User',
    logout: 'Log out',
    darkMode: 'Dark mode',
    delete: 'Delete',
    uploadFile: 'Upload file',
    minCharacterCount: 'Enter at least {{count}} characters',
    loadingData: 'Loading data',
    missingStateParameter: 'Mandatory state parameter is missing'
};
const dropZone = {
    infoText: 'Allowed file types <strong>{{extensions, list}}</strong>. Maximum file size <strong>{{size, number(style: unit; unit: megabyte)}}</strong>.',
    totalAcceptSize: 'Total maximum size <strong>{{size, number(style: unit; unit: megabyte)}}</strong>.',
    chipWithSize: '{{name}} ({{size, number(style: unit; unit: megabyte)}})',
    choseFileDesktop: 'choose file',
    choseFileMobile: 'Choose file',
    dragFile: 'Drag file here or',
    wrongFormat: 'This format is not supported.'
};
const mimeTypes = {
    //audio,application,image,text,video,font
    'mime-audio': 'audio files',
    'mime-application': 'application files',
    'mime-image': 'images',
    'mime-text': 'text files',
    'mime-video': 'video files',
    'mime-font': 'fonts'
};
const externalLink = {
    externalLinkLoading: 'Loading external link, please wait...',
    externalLinkError: 'An error occurred while loading the external link'
};
const messages = Object.assign({}, common, person, special, auth, generic, dropZone, mimeTypes, externalLink);
export default Object.assign({}, messages, createLabeledMessages(messages));
